import { getSpecificationItems } from '../../utils/get-specification-items.js';

const getSharedFrameSpecificationItems = ({ segment , trend , lensFeatures , frameFeatures , prescriptionGlass  })=>{
    const { lensColor , isGlazeble , isPolarized  } = lensFeatures || {};
    const { color: frameColor , shape: frameShape , material: frameMaterial , type: frameType , size: frameSize , templeType ,  } = frameFeatures || {};
    const serverSpecifications = {
        segment,
        frameShape: frameShape === null || frameShape === void 0 ? void 0 : frameShape.displayName,
        lensColor,
        frameColor,
        frameMaterial,
        frameType,
        frameSize: frameSize === null || frameSize === void 0 ? void 0 : frameSize.displayName,
        isGlazeble,
        isPolarized,
        templeType,
        trend,
        prescriptionGlass
    };
    return getSpecificationItems(serverSpecifications);
};

export { getSharedFrameSpecificationItems };
//# sourceMappingURL=get-shared-frame-specification-items.js.map
